import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    return network.post('api/bo/renameVersion', params).then((response) => {
        return response.data;
    });
};
export const useMutationRenameVersion = () => {
    return useMutation<unknown, QueryError, IRenameVersion>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameVersion {
    metaDataid: number;
    versionName: string;
}
